import styled from "styled-components";

export const DeletedText = styled.span`
  font-style: italic;
  color: ${props => props.theme.colors.deletedMessage};
`;
